"use client";

import { ImageIcon, Loader2 } from "lucide-react";
import { useProductImage } from "@/hooks/useProductImagesBatch";
import { useFeatureFlag } from "@/query/hooks/useFeatureFlags";
import type { FlowCellProps } from "./types";

export function ImageCell({ flow }: Readonly<FlowCellProps>) {
  const showProductImages = useFeatureFlag("showProductImages") !== false;
  const firstImageUrl = showProductImages
    ? (flow.product?.image_urls?.[0] ?? null)
    : null;
  const { url, loading } = useProductImage(firstImageUrl);

  if (loading) {
    return (
      <div className="flex items-center justify-center w-10 h-10 rounded bg-muted">
        <Loader2 className="h-3 w-3 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!url) {
    return (
      <div className="flex items-center justify-center w-10 h-10 rounded bg-muted">
        <ImageIcon className="h-3 w-3 text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="relative w-10 h-10 overflow-hidden rounded bg-muted">
      <img
        src={url}
        alt={flow.product?.short_name || flow.product?.name || "Product"}
        className="absolute inset-0 w-full h-full object-cover"
      />
    </div>
  );
}
